<template>
  <form class="form-single" v-on:submit.prevent="verifyAndSubmit">
    <div class="row">
      <div class="col-1">
        <h3 class="title">Me Ligue</h3>
      </div>
    </div>
    <div class="row">
      <div style="padding-right: 10px;" class="col-1-2">
        <div class="row">
          <div class="col-1">
            <div class="form-group">
              <label for>URL</label>
              <input autocomplete="off" type="text" v-model="meLigue.url" class="form-control" />
              <div class="message">{{ validation.firstError('url') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="border-left: 1px solid #ccc; padding-left: 10px;" class="col-1-2">
        <div class="row">
          <div class="col-1">
            <div class="form-group">
              <label for>Chave de API</label>
              <input autocomplete="off" type="text" v-model="meLigue.apiKey" class="form-control" />
              <div class="message">{{ validation.firstError('apiKey') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <button class="button button-success">Salvar</button>
    </div>
  </form>
</template>
<script>

import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;
const url = "/configuracao/me-ligue";

export default {
  name: "MeLigue",
  props: ["meLigue", "onSubmit"],
  validators: {},
  methods: {
    verifyAndSubmit() {
      this.$validate().then(success => {
        if (success) {
          this.onSubmit({ meLigue: this.meLigue });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Config/Avancado/MeLigue.vue